module.exports = __webpack_public_path__ + "img/Girl_020025.a5361b41.png";